import { TdtUser } from "../../model/TdtUserJs";

/*
 * @Author: your name
 * @Date: 2019-11-12 16:09:25
 * @LastEditTime: 2019-11-15 16:28:43
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \source\src\components\onlineMap\mainMap\UCOverlay\DrawPolycurveOverlayJs.js
 */



export class DrawPolycurveOverlayJs {

    constructor() {

        this.id_addCollectItem = "id_addCollectItem";


        this.drawItem = null;


        this.ucOverLay = null;

        this.ucFormCollectFolder = null;

    }



    init() {

        this.ucOverLay.curDrawItem = this.drawItem;
        this.ucOverLay.init();

        this.ucFormCollectFolder.tagObject = this.drawItem;

    }

    /**
 * 绑定事件
 */
    bindingEvents() {

        //绑定元素事件
        this._bindingDomElementEvents();

    }

    ucRenderFinished(callback) {
        let self = this;
        this.ucOverLay.$nextTick(function () {

            let innerHtml = self.ucOverLay.$el.innerHTML;
            if (callback) {
                callback(innerHtml);
            }
        });



    }

    off_selectCollectFolderFinished(callback) {
        this.ucFormCollectFolder.off_selectFolderFinished(callback);
    }


    on_selectCollectFolderFinished(callback) {
        this.ucFormCollectFolder.on_selectFolderFinished(callback);
    }

    _bindingDomElementEvents() {
        let self = this;

        let eleAddCollectItem = document.getElementById(this.id_addCollectItem);
        eleAddCollectItem.onclick = function (evt) {
            if (!TdtUser.currentUser) {
                self.ucOverLay.$message({
                    showClose: true,
                    type: "info",
                    message: "请先登录!"
                });

                return;
            }

            self._addCollectItem();
        };

    }


    _addCollectItem() {

        this.ucFormCollectFolder.init();
        this.ucFormCollectFolder.showForm();

    }








}

export const DrawPolycurveOverlayEvents =
{
    UCFormSelectCollectFolder_event_selectFolderFinished: "event_UCFormSelectCollectFolder_event_selectFolderFinished",


}